module.exports = __webpack_public_path__ + "img/9788980402298.13594f0f.jpg";